<template>
  <div class="header-cover">
    <img class="header-cover-img" :src="coverUrl">
    <img class="header-cover-dim" src="../../../public/image/Instrument/157.png">
  </div>
</template>

<script>
export default {
  name: 'HeaderCover',
  props: {
    coverUrl: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.header-cover{
  position: relative;
  background: #ffffff;
  .header-cover-img{
    width: 100%;
    min-height: 100px;
  }
  .header-cover-dim{
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
</style>
